import {NewTableDef, TableColumnDef} from 'app/shared/tables/table-column-def';

export class CompetitorsPricesQueryList {
    Id: number;
    EANCode: number;
    SKUName: string;
    RegistrationName: string;
    CompStoreName: string;
    RegistrationDate: Date;
    ImportDate: Date;
    CompPrice: number;
    CompPromoPrice: string;
    PriceType: string;
    RegistrationSource: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'CompetitorsPricesQueryList',
            columns: [
                {columnDef: 'Id'},
                {
                    field: 'EanCode',
                    columnDef: 'EanCode',
                    header: 'EAN',
                    filterValue: 'EANs',
                    width: 10,
                    tooltipEnabled: true,
                },
                {
                    field: 'SkuName',
                    columnDef: 'SkuName',
                    header: 'SKU',
                    isGeneralSearchColumn: true,
                    width: 10,
                    tooltipEnabled: true,
                },
                {
                    field: 'RegistrationName',
                    columnDef: 'RegistrationName',
                    header: 'Nazwa Spisu',
                    width: 10,
                    tooltipEnabled: true,
                },
                {
                    field: 'CompStoreName',
                    columnDef: 'CompStoreName',
                    header: 'Placówka konkurencji',
                    filterValue: 'CompStoreNames',
                    width: 10,
                    tooltipEnabled: true,
                },
                {
                    field: 'RegistrationDate',
                    columnDef: 'RegistrationDate',
                    header: 'Data spisu',
                    width: 10,
                    type: 'date',
                    showSearch: false
                },
                {
                    field: 'ImportDate',
                    columnDef: 'ImportDate',
                    header: 'Data importu',
                    width: 10,
                    type: 'date',
                    showSearch: false
                },
                {
                    field: 'CompPrice',
                    columnDef: 'CompPrice',
                    header: 'Cena',
                    width: 8,
                    suffix: 'currency',
                    type: 'currency',
                    showSearch: false
                },
                {field: 'CompPromoPrice', columnDef: 'CompPromoPrice', header: 'Promo', width: 8},
                {field: 'PriceType', columnDef: 'PriceType', header: 'Rodzaj', width: 8},
                {field: 'RegistrationSource', columnDef: 'RegistrationSource', header: 'Źródło', width: 10},
                // {field: 'EANCode', columnDef: 'select', width: 6},
            ]
        };
    }
}

export class CompetitorsPricesImportsQueryList {
    RegistrationName: string;
    CompStoreName: string;
    Address: string;
    RegistrationDate: Date;
    RegistrationSource: string;
    FileName: string;
    FullFileName: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'CompetitorsPricesImportsQueryList',
            columns: [
                {columnDef: 'FullFileName'},
                {
                    field: 'RegistrationName',
                    columnDef: 'RegistrationName',
                    header: 'Nazwa Spisu',
                    filterValue: 'RegistrationName',
                    width: (100 - 5) / 6,
                },
                {
                    field: 'CompStoreName',
                    columnDef: 'CompStoreName',
                    header: 'Placówka konkurencji',
                    filterValue: 'CompStoreName',
                    width: (100 - 5) / 6,
                },
                {field: 'Address', columnDef: 'Address', header: 'Adres', width: (100 - 5) / 6},
                {
                    field: 'RegistrationDate',
                    columnDef: 'RegistrationDate',
                    header: 'Data spisu',
                    width: (100 - 5) / 6,
                    type: 'date',
                    tooltipDisabled: true,
                },
                {
                    field: 'FileName',
                    columnDef: 'FileName',
                    header: 'Data importu',
                    width: (100 - 5) / 6,
                    type: 'dateFromFileName',
                    isGeneralSearchColumn: true,
                    tooltipDisabled: true,
                },
                {
                    field: 'RegistrationSource',
                    columnDef: 'RegistrationSource',
                    header: 'Źródło',
                    width: (100 - 5) / 6
                },
                // 5% for action button
            ]
        };
    }

    public static GetObject(fullFileName: string) {
        const object = new CompetitorsPricesImportsQueryList();
        object.FullFileName = fullFileName;

        const values = fullFileName.replace(/_/g, ' ').split('$');
        const pattern = /(\d{4})(\d{2})(\d{2})/;
        const formatedDate = values[3].replace(pattern, '$1-$2-$3');

        object.RegistrationName = values[0];
        object.CompStoreName = values[1];
        object.Address = values[2];
        object.RegistrationDate = new Date(formatedDate);
        object.RegistrationSource = values[4];
        object.FileName = values[5];
        return object;
    }

    public toString(): string {
        const formatedRegistrationDate = this.RegistrationDate.toISOString()
            .slice(0, 10)
            .replace(/-/g, '');
        return `${this.RegistrationName}$${this.CompStoreName}$${this.Address}$${formatedRegistrationDate}$${this.RegistrationSource}$${this.FileName}`
            .replace(/ /g, '_')
            .replace('.csv', '');
    }
}

export class CompetitorImportPricesListQuery {
    Id: number;
    RegistrationName: string;
    CompetitorStoreId: string;
    RegistrationDate: Date;
    Ean: string;
    SKUName: string;
    RegularPrice: string;
    PromoPrice: string;
    Source: string;
    SKUCategory: string;
    Weight: number;
    unitOfMeasure: string;
    IsApproved: boolean;
    Alert: ImportAlert;
    // add uniqId to have unique key for
    // because id is not unique
    UniqId: number;

    public static tableInfo(screenWidth: number): NewTableDef {
        return {
            tableId: 'CompetitorImportPricesListQuery',
            columns: [
                {columnDef: 'UniqId'},
                {
                    field: 'Ean',
                    columnDef: 'Ean',
                    sortColumnDef: 'Ean',
                    header: 'EAN',
                    filterValue: 'EANs',
                    width: screenWidth / 8,
                },
                {
                    field: 'SkuName',
                    columnDef: 'SkuName',
                    sortColumnDef: 'SKUName',
                    header: 'Nazwa SKU',
                    width: screenWidth / 8,
                },
                {
                    field: 'RegularPrice',
                    columnDef: 'RegularPrice',
                    sortColumnDef: 'RegularPrice',
                    header: 'Cena',
                    width: screenWidth / 8,
                    tooltipDisabled: true,
                },
                {
                    field: 'PromoPrice',
                    columnDef: 'PromoPrice',
                    sortColumnDef: 'PromoPrice',
                    header: 'Promo',
                    width: screenWidth / 8,
                    tooltipDisabled: true,
                },
                {
                    field: 'SkuCategory',
                    columnDef: 'SkuCategory',
                    sortColumnDef: 'SKUCategory',
                    header: 'Kategoria SKU',
                    width: screenWidth / 8,
                },
                {
                    field: 'Weight',
                    columnDef: 'Weight',
                    sortColumnDef: 'Weight',
                    header: 'Gramatura',
                    width: screenWidth / 8,
                    tooltipDisabled: true,
                },
                {
                    field: 'UnitOfMeasure',
                    columnDef: 'UnitOfMeasure',
                    sortColumnDef: 'UnitOfMeasure',
                    header: 'Jednostka',
                    width: screenWidth / 8,
                    tooltipDisabled: true,
                },
                {
                    field: 'IsApproved',
                    columnDef: 'IsApproved',
                    sortColumnDef: 'IsApproved',
                    header: 'Status',
                    width: screenWidth / 8,
                    type: 'approved',
                    showSort: false,
                    showSearch: false
                },
            ]
        };
    }
}

export class ApproveCompetitorPricesRequest {
    LogicName: string;
    ApprovedCompetitorsPrices: CompetitorImportPricesListQuery[] = [];
}

export class ImportAlert {
    AlertType: string;
    alertMessage: string;
}
